'use client';

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/app/[locale]/auth/(presentation)/store/auth.store';
import { logger } from '@/core/utils/logger';

/**
 * Componente que inicializa el estado de autenticación al cargar la aplicación
 * Este componente debe ser incluido en el layout principal para asegurar
 * que el estado de autenticación se verifique en cada recarga de la página
 */
export function AuthInitializer() {
  const checkAuthStatus = useAuthStore((state) => state.checkAuthStatus);
  const [isHydrated, setIsHydrated] = useState(false);

  // Esperar a que Zustand se hidrate desde el storage
  useEffect(() => {
    // Zustand persist tiene un evento de hidratación
    const unsubFinishHydration = useAuthStore.persist.onFinishHydration(() => {
      setIsHydrated(true);
      logger.debug('Auth store hydration finished', { module: 'auth-initializer' });
    });

    // Si ya está hidratado (puede pasar si el storage es síncrono)
    if (useAuthStore.persist.hasHydrated()) {
      setIsHydrated(true);
    }

    return () => {
      unsubFinishHydration();
    };
  }, []);

  useEffect(() => {
    // Solo verificar el estado de autenticación después de la hidratación
    if (!isHydrated) return;

    const initializeAuth = async () => {
      try {
        await checkAuthStatus();
      } catch (error) {
        const normalizedError = error instanceof Error ? error : new Error(String(error));
        logger.error('Error al inicializar el estado de autenticación:', normalizedError, {
          module: 'auth',
          action: 'initializeAuth',
        });
      }
    };

    initializeAuth();
  }, [checkAuthStatus, isHydrated]);

  return null;
}
